import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import './EditorPlain.scss';

// Used to display the contents of a WYSIWYG editor without the toolbars and border
export class EditorPlain extends Component {

    render(){
        return (
            <div className="editor-plain">
                <Editor
                    readOnly={true}
                    editorClassName={this.props.className}
                    defaultContentState={this.props.jsonMessage}
                />                
            </div>
        )
    }
}

EditorPlain.propTypes = {
    jsonMessage: PropTypes.object.isRequired,
    className: PropTypes.string
}

export default EditorPlain;